<template>
    <div id="create-marketing-lead-popup">
        <vx-card>
            <template slot="actions">
                <div class="vx-row">
                    <vx-tooltip class="mr-2" text="ASSESS SALES OPPORTUNITY" position="top"
                        v-if="!form.customer_id && !['Closed NIO', 'Subscriber', 'Pending', 'Junk'].includes(form.status)">
                        <vs-button @click.stop="onClickProcess()" size="" color="primary" type="border" icon-pack="feather"
                            icon="icon-plus">ASSESS SALES OPPORTUNITY</vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" text="SHOW PREVIOUS OPPORTUNITY" position="top">
                        <vs-button @click.stop="onClickViewBantData()" size="" color="warning" type="border"
                            icon-pack="feather" icon="icon-align-justify">PREVIOUS OPPORTUNITIES</vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" text="CONVERT TO A LEAD" position="top" v-if="form.status === 'Pending'">
                        <vs-button @click.stop="onClickChangeStatus('Lead')" size="" color="primary" type="filled"
                            icon-pack="feather" icon="icon-align-justify">CONVERT TO A LEAD</vs-button>
                    </vx-tooltip>
                </div>
            </template>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form id="create-marketing-lead-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                                <small class="label">Status</small>
                                <v-select :clearable="false" placeholder="" v-model="form.status"
                                    :options="['Pending', 'Lead', 'Subscriber', 'Junk']" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    :disabled="form.status === 'Opportunity'">
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <!-- <div class="w-full vx-col md:w-1/2 md:mb-0" v-if="isCreateMode">
                            <ValidationProvider vid="mailchimp" name="mailchimp" rules="" v-slot="{ errors }">
                                <small class="label">Status (mailchimp)</small>
                                <v-select :clearable="false" placeholder="" v-model="form.mailchimp_status"
                                    :options="['pending', 'subscribed', 'unsubscribed', 'cleaned', 'transactional']"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="!isCreateMode">
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div> -->
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="mailchimp_member_id" name="mailchimp_member_id" rules=""
                                v-slot="{ errors }">
                                <small class="label">Mailchimp Status</small>
                                <vs-input disabled :value="form.mailchimp_member_id ? 'Linked' : 'Not Linked'" name="mailchimp_member_id"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                                <small class="label">First Name</small>
                                <vs-input v-model="form.first_name" name="first_name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                                <small class="label">Last Name</small>
                                <vs-input v-model="form.last_name" name="last_name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="email_address" name="email_address" rules="required|email"
                                v-slot="{ errors }">
                                <small class="label">Email Address</small>
                                <vs-input v-model="form.email" name="email_address" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="company_name" name="company_name" rules="" v-slot="{ errors }">
                                <small class="label">Company Name</small>
                                <vs-input v-model="form.company_name" name="company_name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="industry_sector" name="industry_sector" rules="required"
                                v-slot="{ errors }">
                                <small class="label">Industry Sector</small>
                                <v-select multiple v-on:input="onChangeIndustrySector" :clearable="false"
                                    :closeOnSelect="false" name="industry_sector" placeholder="" label="name"
                                    v-model="form.sector" :reduce="option => option.id" :options="industrySectors"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                </v-select>

                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="industry_sub_sector" name="industry_sub_sector" rules=""
                                v-slot="{ errors }">
                                <small class="label">Industry Sub Sector</small>
                                <v-select multiple :clearable="false" :closeOnSelect="false" name="industry_sub_sector"
                                    placeholder="" label="name" v-model="form.sub_sector" :reduce="option => option.id"
                                    :options="industrySubSectors" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        Please select Industry Sector first!
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="source" name="source" rules="required" v-slot="{ errors }">
                                <small class="label">Source</small>
                                <v-select multiple v-on:input="onChangeCustomerSource" :clearable="false"
                                    :closeOnSelect="false" name="industry_sector" placeholder="" label="name"
                                    v-model="form.source" :reduce="option => option.id" :options="customerSources"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                </v-select>

                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="sub_source" name="sub_source" rules="required" v-slot="{ errors }">
                                <small class="label">Sub Source</small>
                                <v-select multiple :clearable="false" :closeOnSelect="false" name="sub_source"
                                    placeholder="" label="name" v-model="form.sub_source" :reduce="option => option.id"
                                    :options="customerSubSources" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        Please select Industry Sector first!
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="account_handler_id" name="account_handler_id" rules=""
                                v-slot="{ errors }">
                                <small class="label">Account Handler</small>
                                <v-select :clearable="false" name="account_handler_id" placeholder="" label="name"
                                    :reduce="option => option.value" v-model="form.account_handler_id" :options="account_handlers"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="country" name="country" rules="" v-slot="{ errors }">
                                <small class="label">Country</small>
                                <v-select :clearable="false" name="country" placeholder="" label="name"
                                    :reduce="option => option.name" v-model="form.country" :options="countries"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0 mb-2 pt-1" v-for="(field, index) in merge_fields"
                            :key="index" v-if="!field.is_hidden">
                            <ValidationProvider :vid="field.name" :name="field.name"
                                :rules="field.is_required ? 'required' : ''" v-slot="{ errors }"
                                v-if="field.type === 'text'" class="mb-4">
                                <small class="label">{{ field.name }}</small>
                                <vs-input v-model="field.value" :name="field.name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                            <ValidationProvider :vid="field.name" :name="field.name"
                                :rules="field.is_required ? 'required' : ''" v-slot="{ errors }"
                                v-if="field.type === 'dropdown'">
                                <small class="label">{{ field.name }}</small>
                                <v-select :clearable="false" placeholder="" v-model="field.value"
                                    :options="field.data.dropdown" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="follow_up_date" name="follow_up_date" rules="" v-slot="{ errors }">
                                <small class="label">Follow Up Date</small>
                                <flat-pickr :config="{ enableTime: false, dateFormat: 'd/m/Y' }" class="hidden"
                                    v-model="form.follow_up_date" placeholder="Choose Date" />
                                <flat-pickr :config="{ enableTime: false, dateFormat: 'd/m/Y' }" class="w-full"
                                    v-model="form.follow_up_date" placeholder="Choose Date" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="currency" name="currency" rules="" v-slot="{ errors }">
                                <small class="label">Currency</small>
                                <v-select :disabled="is_currency_already_set" :clearable="false" name="account_currency" placeholder="" label="currency"
                                    :reduce="option => option.currency" v-model="form.account_currency" :options="account_currencies"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="enquiry" name="enquiry" rules="" v-slot="{ errors }">
                                <small class="label">Initial Enquiry</small>
                                <vs-textarea class="mb-0" v-model="form.enquiry" height="100px" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col">
                            <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                                <small class="label">Notes</small>
                                <vs-textarea class="mb-0" v-model="form.notes" height="150px" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <!-- Save & Reset Button -->
                    <div class="flex flex-wrap items-center justify-end mt-8">
                        <vs-button button="submit" class="mt-2 ml-auto">Save
                            Changes</vs-button>
                        <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
                    </div>
                </form>
            </ValidationObserver>
        </vx-card>
        <CreateBantPopUp ref="createBantPopUp" />
        <ViewBantDataPopUp ref="viewBantDataPopUp" />
        <UpdateForecast ref="updateForecast" />
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';

const CrmRepository = RepositoryFactory.get('crm');
const CustomerRepository = RepositoryFactory.get('customer');
const CustomerSourceRepository = RepositoryFactory.get('customer_source')
const StaffRepository = RepositoryFactory.get('staff')

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { mapActions, mapGetters } from 'vuex';

import CreateBantPopUp from '@/components/popups/crm/marketing-leads/CreateBantPopUp.vue';
import ViewBantDataPopUp from '@/components/popups/crm/marketing-leads/ViewBantDataPopUp.vue'
import UpdateForecast from "@/components/popups/forecast-tool/UpdateForecast";

export default {
    name: 'LeadProfile',
    data() {
        return {
            id: '',
            merge_fields: [],
            account_currencies: [],
            form: {},
            isCreateMode: true,
            industrySectors: [],
            industrySubSectors: [],
            customerSources: [],
            customerSubSources: [],
            is_currency_already_set: false
        }
    },
    async mounted() {
        this.id = this.$route.params.id
        await this.fetchMergeFields();
        await this.loadIndustrySectors();
        await this.loadCustomerSources();
        await this.fetchCountries()
        await this.fetchAccountHandlers()
        await this.fetchAccountCurrencies();
        await this.fetchLeadDetails()
        await this.increaseLeadOpenCount()
    },
    methods: {
        ...mapActions(['fetchCountries', 'fetchAccountHandlers']),
        async refreshData() {
            await this.fetchLeadDetails()
        },
        async fetchAccountCurrencies() {
          const {data} = (await StaffRepository.getCurrencyList()).data
          this.account_currencies = data.map((x) => ({ currency: x.code }));
        },
        async fetchLeadDetails() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                const { data } = (await CrmRepository.getMerketingLeadDetails(this.id)).data
                this.form = data
                this.is_currency_already_set = !!data.account_currency
                this.merge_fields = this.merge_fields.map((x) => {
                    const find = this.form.merge_fields.find((y) => y.tag === x.tag)
                    x.value = find ? find.value : (find.default_value ? find.default_value : '')
                    return x
                })
                if (this.form.sub_sector.length !== 0) {
                    const { data } = (await CustomerRepository.getIndustrySubSectors({ ids: this.form.sector })).data
                    this.industrySubSectors = data
                }
                if (this.form.sub_source.length !== 0) {
                    const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: this.form.source })).data
                    this.customerSubSources = data
                }
                if (!!this.form.customer_id) {
                    this.$router.push(`/pages/manage-nimble/customers/${this.form.customer_id}`)
                }
            } catch (e) {
                this.convertAndNotifyError(e);
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async increaseLeadOpenCount() {
            try {
                await CrmRepository.increaseLeadOpenCount(this.id)
            } catch (error) {

            }
        },
        async loadIndustrySectors() {
            const { data } = (await CustomerRepository.getIndustrySectors()).data
            this.industrySectors = data
        },
        async onChangeIndustrySector(ids) {
            await this.$vs.loading();
            try {
                this.form.sub_sector = []
                const { data } = (await CustomerRepository.getIndustrySubSectors({ ids: ids })).data
                this.industrySubSectors = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            await this.$vs.loading.close()
        },
        async loadCustomerSources() {
            const { data } = (await CustomerSourceRepository.getListOfCustomerSource()).data
            this.customerSources = data
        },
        async onChangeCustomerSource(ids) {
            await this.$vs.loading();
            try {
                this.form.sub_source = []
                const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: ids })).data
                this.customerSubSources = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            await this.$vs.loading.close()
        },
        async fetchMergeFields() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                const { data } = (await CrmRepository.getCrmMergedFields())
                this.merge_fields = data.data.filter((x) => !x.is_hidden).map((x) => { x.value = x.default_value ? x.default_value : ''; return x; })
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async onClickCreateSite() {
            const vue = this;
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                let payload = {}
                Object.assign(payload, this.form)
                payload.merge_fields = this.merge_fields.map((x) => ({ tag: x.tag, value: x.value }))
                if (payload.status === 'Opportunity') delete payload.status
                await CrmRepository.updateMerketingLead(this.id, payload);
                this.showSuccessMessage('Lead updated successfully!');
            } catch (e) {
                this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        onClickViewBantData() {
            this.$refs.viewBantDataPopUp.openPopup(this.id)
        },
        onClickProcess() {
            this.$refs.createBantPopUp.openPopup(this.id, this.form.company_name, this.form)
        },
        async onClickViewForecast() {
            if (!!this.form) {
                await this.$refs.updateForecast.openPopup({ data: this.form, customer_type: 'lead' })
            }
        },
        async onClickChangeStatus(status) {
            await this.$vs.loading()
            try {
                await CrmRepository.changeMarketingLeadStatus(this.id, { status })
                this.$router.push(`/pages/crm/marketing-leads-suspect/${this.id}`)
                location.reload()
            } catch (error) {
                this.convertAndNotifyError(error)
            }
            await this.$vs.loading.close()
        }
    },
    components: {
        flatPickr,
        'v-select': vSelect,
        ViewBantDataPopUp,
        CreateBantPopUp,
        UpdateForecast
    },
    computed: {
        ...mapGetters(['countries', 'account_handlers'])
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
<style lang="">

</style>
